import ModuleInViewAnimationContainer from './moduleInViewAnimationContainer';
import { Flex, Text, FormErrorMessage } from '@chakra-ui/react';
import BundleIcon from "../../../_Base/Components/bundleIcon";


type MessageProps = {
	isSuccess: boolean;
	children: React.ReactNode | string;
	additionalMessage?: React.ReactNode | string;
}

type InputErrorMessageProps = {
	width?: string;
	children: React.ReactNode | string;
}

const Message = ({ isSuccess, children, additionalMessage }: MessageProps) => {
	return (
		<ModuleInViewAnimationContainer>
			<Flex
				bg={isSuccess ? "support.successGreen.normal" : "support.errorRed.normal"}
				flexDir="row"
				w="100%"
				py="xs"
				px="sm"
				transition="all 0.2s ease-in-out"
				mb="lmd"
				borderRadius="3px"
				gap="xs"
				color="primary.white"
			>
				<BundleIcon name="exclamation" aria-hidden="true" fill="currentColor" mt="4px" />
				<Flex flexDir="column" gap="xxs">
					<Text>
						{children}
					</Text>
					{additionalMessage && <Text>{additionalMessage}</Text>}
				</Flex>
			</Flex>
		</ModuleInViewAnimationContainer>
	)
};

export const InputErrorMessage = ({ children, width, ...rest }: InputErrorMessageProps) => {
	return (
		<FormErrorMessage
			display="flex"
			alignItems="center"
			gap="xs"
			transition="all 0.2s ease-in-out"
			background="support.errorRed.normal"
			color="primary.white"
			fontSize="xs"
			mt="-xs"
			px="xs"
			py="xxs"
			width={width}
			{...rest}
		>
			<BundleIcon name="exclamation" aria-hidden="true" fill="currentColor" />
			<Text size="bodyS">
				{children}
			</Text>
		</FormErrorMessage>
	)
}

export default Message; 